<div class="d-flex flex-column justify-content-center flex-sm-wrap flex-sm-row focused-test">
	<div *ngFor="let option of options" data-toggle="buttons" [attr.aria-label]="option.label|translate" class="focused-test">
		<label>
			<input type="radio" value="YES" style="position: absolute; opacity: 0;" name="radioInput" (change)="onSelect(option.id)" tabindex="-1">
			<div class="m-box btn-group-toggle square" [ngClass]="{'selected':option.id===selectedOption}" tabindex="0" [attr.data-id]="option.id" data-source="boxImage">
				<div class="m-box-image {{option.class}}"></div>
				<div class="m-box-title mx-auto">{{option.label|translate}} </div>
			</div>
		</label>
		<br/>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/box-selector/box-selector.component.html